import { Component, ChangeDetectionStrategy } from '@angular/core';
import { isEmpty, isNil, find } from 'lodash';
import { IHeaderGroupParams, RowNode } from 'ag-grid-community';
import { IHeaderGroupAngularComp } from 'ag-grid-angular';
import { LinkParams } from './link-ag-renderer.component';

interface HeaderGroup extends IHeaderGroupParams {
    node?: RowNode;
}

@Component({
    selector: 'header-group',
    template: require('./header-group-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderGroupRenderer implements IHeaderGroupAngularComp {
    public params: LinkParams;
    public groupTypeName: string;
    private count: number;

    public agInit(params: HeaderGroup) {
        const data = params.node.key;
        const rowGroupIndex = params.node.rowGroupIndex;
        const groupColumn = find(params.columnApi.getAllColumns(), (col) => col.getColDef().rowGroupIndex === rowGroupIndex);
        this.groupTypeName = groupColumn.getColDef().headerName;
        
        if (!isNil(data)) {
            const isLinkParams = !isNil(data.routerLink);
            if (isLinkParams) {
                this.params = data;
            } else {
                this.params = {
                    routerLink: [],
                    text: data
                };
            }

            this.count = params.node.allChildrenCount;
        }
    }

    public get isText() {
        return this.params && isEmpty(this.params.routerLink);
    }

    public get isLink() {
        return this.params && !isEmpty(this.params.routerLink);
    }

    public get title() {
        return this.params ? `${this.params.text} (${this.count})` : null;
    }
}